import { createAsyncThunk } from '@reduxjs/toolkit'
import * as services from '@services/fonts.services'
import { FONTS_ACTION_TYPE } from './types'

export const fontList = createAsyncThunk<
  services.FontsResponse,
  services.FontsParams
>(FONTS_ACTION_TYPE.LIST, async (params, { rejectWithValue }) => {
  try {
    const res = await services.list(params)
    return res
  } catch (err) {
    const error: any = err
    if (!error.response) {
      throw error
    }
    return rejectWithValue(error.response.data)
  }
})

export const fontActiveList = createAsyncThunk<services.FontsResponse>(
  FONTS_ACTION_TYPE.ACTIVE_LIST,
  async (_, { rejectWithValue }) => {
    try {
      const res = await services.activeList()
      return res
    } catch (err) {
      const error: any = err
      if (!error.response) {
        throw error
      }
      return rejectWithValue(error.response.data)
    }
  }
)

export const fontCreate = createAsyncThunk<
  services.FontDetail,
  services.FontCreateParams
>(FONTS_ACTION_TYPE.CREATE, async (params, { rejectWithValue }) => {
  try {
    const res = await services.create(params)
    return res
  } catch (err) {
    const error: any = err
    if (!error.response) {
      throw error
    }
    return rejectWithValue(error.response.data)
  }
})

export const fontUpdate = createAsyncThunk<
  services.FontDetail,
  services.FontUpdateParams
>(FONTS_ACTION_TYPE.UPDATE, async (params, { rejectWithValue }) => {
  try {
    const res = await services.update(params)
    return res
  } catch (err) {
    const error: any = err
    if (!error.response) {
      throw error
    }
    return rejectWithValue(error.response.data)
  }
})

export const fontFilesUpdate = createAsyncThunk<
  services.FontDetail,
  services.FontUpdateParams
>(FONTS_ACTION_TYPE.UPDATE_FILES, async (params, { rejectWithValue }) => {
  try {
    const res = await services.update(params)
    return res
  } catch (err) {
    const error: any = err
    if (!error.response) {
      throw error
    }
    return rejectWithValue(error.response.data)
  }
})

export const fontDetail = createAsyncThunk<services.FontDetail, string>(
  FONTS_ACTION_TYPE.DETAIL,
  async (id, { rejectWithValue }) => {
    try {
      const res = await services.detail(id)
      return res
    } catch (err) {
      const error: any = err
      if (!error.response) {
        throw error
      }
      return rejectWithValue(error.response.data)
    }
  }
)

export const fontDelete = createAsyncThunk<
  services.FontsResponse,
  services.FontDeleteParams
>(FONTS_ACTION_TYPE.DELETE, async (params, { rejectWithValue }) => {
  try {
    const res = await services.deleteFont(params)
    return res
  } catch (err) {
    const error: any = err
    if (!error.response) {
      throw error
    }
    return rejectWithValue(error.response.data)
  }
})

export const fontStatus = createAsyncThunk<
  services.FontStatusResponse,
  services.FontStatusParams
>(FONTS_ACTION_TYPE.STATUS, async (params, { rejectWithValue }) => {
  try {
    const res = await services.status(params)
    return res
  } catch (err) {
    const error: any = err
    if (!error.response) {
      throw error
    }
    return rejectWithValue(error.response.data)
  }
})
